var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.formConfig.templateCode,{tag:"component",attrs:{"formConfig":_vm.formConfig,"trackData":_vm.trackData}})}
var staticRenderFns = []

export { render, staticRenderFns }